import type { MatchHistoryPageDto } from '@redpandev/shared';

/**
 * Historique PUBLIC d'un joueur — endpoint API existant
 * `GET /api/profile/:displayName/history` (ProfileController, route publique),
 * paginé par curseur `finishedAt` ISO (spec 01 §8 / spec 08 §3).
 * Aucune donnée privée : le serveur ne renvoie que des résultats de parties
 * terminées (jamais de secret de manche — ADR 0003).
 *
 * Volontairement local au dossier profil pour ne pas éditer `lib/api.ts`
 * (fichier partagé entre chantiers) ; à promouvoir dans `api` plus tard.
 */
export async function fetchHistory(
  displayName: string,
  opts: { cursor?: string; limit?: number } = {},
): Promise<MatchHistoryPageDto> {
  const params = new URLSearchParams({ limit: String(opts.limit ?? 20) });
  if (opts.cursor) params.set('cursor', opts.cursor);
  const res = await fetch(
    `/api/profile/${encodeURIComponent(displayName)}/history?${params.toString()}`,
    { credentials: 'include' },
  );
  if (!res.ok) throw new Error(`http_${res.status}`);
  return (await res.json()) as MatchHistoryPageDto;
}
